import { Land, Takeoff, Cash, Checked, NotAvailable, Exchangeable, Refundable } from './Icons';
export const overrideIcons = {
    Land: () => Land,
    Takeoff: () => Takeoff,
    Paid: () => Cash,
    Included: () => Checked,
    NotIncluded: () => NotAvailable,
    Exchangeable: () => Exchangeable,
    Refundable: () => Refundable
};
